<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>Applied for Apprenticeship Roles</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBackToDashboard">
            Back to Dashboard
          </button>
        </div>
      </div>
      <el-alert
        :title="
          'This lists all applications sent to ' + $t('lorganization') + 's'
        "
        type="warning"
        :closable="false"
      ></el-alert>
      <el-table :data="tableData" v-if="!showNoData">
        <el-table-column :label="$t('uorganization')" prop="organisationName">
        </el-table-column>
        <el-table-column label="Position" prop="roleTitle"> </el-table-column>
        <el-table-column label="Matching Percentage" prop="matchedPercentage">
            <template scope="scope">
              <div style="margin-left: 35px;">
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 0 && Math.floor(scope.row.matchedPercentage) <= 10" class="dot-quarter">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 11 && Math.floor(scope.row.matchedPercentage) <= 30" class="dot-half">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 31 && Math.floor(scope.row.matchedPercentage) <= 69" class="dot-third">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 70 && Math.floor(scope.row.matchedPercentage) <= 100" class="dot-whole">{{Math.floor(scope.row.matchedPercentage)}}%</span>
              </div>
            </template>
          </el-table-column>
        <el-table-column label="Employer Status" prop="employerStatusName"></el-table-column>
      </el-table>
    </div>
    <div v-if="showNoData" class="no-data">
      <div>
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x"></i>
          <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
        </span>
        <div class="no-data-text">{{ noDataText }}</div>
      </div>
    </div>
    <!-- <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: {
    TSLoading,
  },
  data() {
    return {
      tableData: [],
      showNoData: false,
      noDataText: "",
      isLoading: false,
    };
  },
  created() {
    this.isLoading = true;
    this.noDataText = "No applications sent";
    this.$store
      .dispatch('apprentice/getAppliedForApprenticeshipRoles', this.currentApprentice)
      .then((res) => {
        this.tableData = res;
        this.showNoData = res.length === 0;
        this.isLoading = false;
      })
      .catch((res) => {
        this.$message.error(res.error);
        this.showNoData = true;
        this.isLoading = false;
      });
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    },
    currentApprentice() {
      return this.$store.state.account.applicant_user_info.apprenticeId
    }
  },
  methods: {
    goBackToDashboard() {
      this.$router.push({ name: "MyApplicationsDashboard" });
    },
  },
};
</script>
